import ArticleInfo from 'src/views/Pages/Dashboard/Supplying/Shopping/RequestMaterial/ArticleInfo.vue';
import Formatter from 'src/class/Formatter';
import i18n from 'src/i18n';
import StatusRequestInfo from 'src/views/Pages/Dashboard/Supplying/Shopping/RequestMaterial/StatusRequestInfo.vue';

const configTable = () => {
    const tableColumns = [
        {
            prop: 'code',
            label: i18n.t('common_words.code'),
            align: 'center',
            minWidth: 120,
            sortable: true,
        },
        {
            prop: 'user_id',
            label: i18n.t('shopping.request_creator'),
            minWidth: 150,
            sortable: true,
            formatter: (row) => {
                return row.user ?
                    `${row.user.first_name} ${row.user.last_name}`
                    : `${i18n.t('common_words.no_assigned')}`;
            },
        },
        {
            prop: 'farm.name',
            label: i18n.t('common_words.farm'),
            minWidth: 150,
            sortable: true,
        },
        {
            prop: 'supplying.name',
            label: i18n.t('inventory.supplying'),
            sortable: true,
            minWidth: 150
        },
        {
            prop: 'created_at',
            label: i18n.t('common_words.creationDate'),
            sortable: true,
            minWidth: 140,
            formatter: (row) => {
                return Formatter.dateFormat(row.created_at);
            }
        },
        {
            prop: 'status_request',
            label: i18n.t('shopping.request_status'),
            sortable: true,
            formatter: StatusRequestInfo,
            align: 'center',
            minWidth: 120,
        },
        {
            prop: 'approving_user_id',
            label: i18n.t('shopping.request_manager'),
            minWidth: 170,
            sortable: true,
            formatter: (row) => {
                return row.approving_user ?
                    `${row.approving_user.first_name} ${row.approving_user.last_name}`
                    : `${i18n.t('common_words.no_assigned')}`;
            },
        },
        {
            prop: 'articles',
            label: i18n.t('shopping.material_request'),
            show: false,
            minWidth: 150,
            formatter: ArticleInfo
        },
        {
            prop: 'description',
            label: `${i18n.t('common_words.description')}`,
            sortable: true,
            show: false
        }
    ];

    return { tableColumns };
}
export default configTable;